import React, { useEffect, useRef } from 'react';
import { Route, Routes, BrowserRouter, Navigate, useNavigate, useLocation, useParams } from 'react-router-dom';
import Domain from '../domainSale';
import DynamicPage from '../dynamicPage';
import paths from './paths';
import Search from '../searchResult';
import { useDomainData } from '../../hooks/useDomainData';
import useDynamicCSS from '../../hooks/useDynamicCSS';
import { useSelector } from 'react-redux';
// import NotFound from '../notFound';
import { awcg_domain } from '../../utils';
import StorePage from '../dynamicStorePage';
import ProductPage from '../dynamicProductPage';
import PrivacyPolicy from '../privacyPolicy';
import CookiePolicy from '../cookiePolicy';
import CookieBanner from '../../components/CookieBanner';
import Undeveloped from '../undeveloped';
import VillageDashboard from '../villageDashboard';
// import PrivateRoute from './PrivateRoute';




const RouterComponent = () => {
  useDomainData()
  const loaded = useSelector(state => state.domainData.data)
  const undeveloped = useSelector(state => state.domainData.undeveloped)
  // const pages = loaded?.pages
  // const cssFilePath = loaded?.css
  // const columns = loaded?.columns
  // useDynamicCSS("master.css");
  // useDynamicCSS(cssFilePath);


  // useEffect(() => {
  //   // Assume valid and aw_domain are defined somewhere else in your code
  //   let valid = false;
  //   // let aw_domain = ...;
    
  //   if(valid !== true) {
  //     // If the subdomain is not valid, redirect to the main domain
  //     window.location.href = `http://${awcg_domain}${window.location.pathname}`;
  //   }
  // }, []); // Empty array ensures this runs only on first render
  
  
  
  const V2_DOMAINS = ['rye.uk'];
  if (V2_DOMAINS.includes(awcg_domain)) {
    return <VillageDashboard />;
  }
  if (undeveloped) {
    return <Undeveloped />;
  }
  if (loaded) {
    return (
      <BrowserRouter>
        <PagesComponent />
      </BrowserRouter>
    );
  }
  else {
    return (
      <p>Loading...</p>
    )
  }
}

/* Resolves the current URL to a DB page inside the single dynamic
   route. Unknown URLs fall back exactly like the old catch-all:
   to the index page, or the first page if there is no index. */
const DynamicPageRoute = ({ pages, defaultColumns }) => {
  const { pageUrl } = useParams();
  const urlKey = (pageUrl || 'index').toLowerCase();
  const page = pages.find((p) => (p.DT_Setting_URL || '').toLowerCase() === urlKey);
  if (!page) {
    const indexPage = pages.find((p) => p.DT_Setting_URL === 'index');
    return <Navigate replace to={indexPage ? '/' : `/${pages[0]?.DT_Setting_URL || ''}`} />;
  }
  return (
    <DynamicPage
      centerJSX={page.DT_Content_EN}
      title={page.DT_Setting}
      data={page}
      columns={{
        leftWidth: page.DT_ColumnLeftWidth,
        leftContent: page.DT_ColumnLeftContent,
        rightWidth: page.DT_ColumnRightWidth,
        rightContent: page.DT_ColumnRightContent,
      }}
      defaultColumns={defaultColumns}
    />
  );
};

const PagesComponent = () =>{
  const loaded = useSelector(state => state.domainData.data)
  const pages = loaded?.pages
  const cssFilePath = loaded?.css
  const columns = loaded?.columns
  const templateId = loaded?.templateId
  useDynamicCSS("master.css");
  useDynamicCSS(cssFilePath);
  const location = useLocation();
 

  const isSubdomain = window.location.hostname.endsWith(`.${awcg_domain}`) && window.location.hostname !== awcg_domain;
  if(isSubdomain){
    window.location.href = `https://${awcg_domain}${location.pathname}${location.search}`;
  }

  
  
  // const location = useLocation();
  // const firstPath = useRef(location.pathname);

  // if(firstPath.current == "/" && location.pathname !== "/"){
  //   firstPath.current = location.pathname
  // }
  // console.log("firstPath::",firstPath.current, "current:",location.pathname, "search params:", location.search)
  // useEffect(() => {
  //   const currentDomain = window.location.hostname;
    
  //   // Check if the current domain is a subdomain of awcg_domain
  //   const isSubdomain = currentDomain.endsWith(`.${awcg_domain}`) && currentDomain !== awcg_domain;
  //   // Assume valid and aw_domain are defined somewhere else in your code
  //   let valid = false
  //   if(isSubdomain) {
  //     if(valid !== true) {
  //       if(firstPath.current !== location.pathname && firstPath.current !== "/"){
  //         console.log("CHANGE OF ROUTE DETECTED ON INVALID SUBDOMAIN:", location.pathname)
  //         // If the subdomain is not valid, redirect to the main domain
  //         window.location.href = `https://${awcg_domain}${location.pathname}${location.search}`;
  //       }
  //     }
  //   }
  // }, [location]); // This effect runs whenever 'location' changes
  const indexPage = pages.find(page => page.DT_Setting_URL === "index");
const fallbackPageURL = pages[0]?.DT_Setting_URL;

console.log("Pages::", pages);

return (
  <>
  <CookieBanner />
  <Routes>
    {/* Login is retired: hide the destination even if the API still lists it */}
    <Route path="login" element={<Navigate to="/" replace />} />
    {templateId === "Shop_Product" ? (
      <>
        <Route path="product/:id" element={<ProductPage />} />
        {pages.map((page, index) => {
          const path = page.DT_Setting_URL === "index" ? "/" : page.DT_Setting_URL;
          return (
            <Route
              key={index}
              path={path}
              element={
                <StorePage
                  centerJSX={page.DT_Content_EN}
                  title={page.DT_Setting}
                  data={page}
                  columns={{
                    leftWidth: page.DT_ColumnLeftWidth,
                    leftContent: page.DT_ColumnLeftContent,
                    rightWidth: page.DT_ColumnRightWidth,
                    rightContent: page.DT_ColumnRightContent,
                  }}
                  defaultColumns={columns}
                />
              }
            />
          );
        })}
      </>
    ) : (
      /* ONE dynamic route for every DB page. React Router remounts the
         element whenever the matched route changes, so per-page routes
         tore down the whole page (and reloaded the left-column widget)
         on every navigation. A single route keeps one DynamicPage
         mounted and only its props change. */
      <Route
        path=":pageUrl?"
        element={<DynamicPageRoute pages={pages} defaultColumns={columns} />}
      />
    )}

    {/* If there's no "index", redirect "/" to first page */}
    {!indexPage && (
      <Route path="/" element={<Navigate replace to={fallbackPageURL} />} />
    )}

    <Route path={paths.SEARCH} element={<Search />} />
    <Route path={paths.DOMAIN} element={<Domain />} />
    <Route path={paths.PRIVACY_POLICY} element={<PrivacyPolicy />} />
    <Route path={paths.COOKIE_POLICY} element={<CookiePolicy />} />

    {/* Catch-all fallback */}
    <Route path="*" element={<Navigate replace to={indexPage ? "/" : fallbackPageURL} />} />
  </Routes>
  </>
  );
}
//   return(
//           <Routes>
//             {/* <Route path="/" element={<StorePage/>}/> */}
//             {templateId === "Shop_Product"?
//             <>
//               <Route path="product/:id" element={<ProductPage />} />;
//               {pages.map((page, index) => (
//                 <Route key={index} path={page.DT_Setting_URL} element={<StorePage centerJSX={page.DT_Content_EN} title={page.DT_Setting} data={page} columns={(page.DT_ColumnLeftWidth, page.DT_ColumnLeftContent, page.DT_ColumnRightWidth, page.DT_ColumnRightContent )} defaultColumns={columns}/>} exact />
//               ))}
//             </>
//             :
//             pages.map((page, index) => (
//               <Route key={index} path={page.DT_Setting_URL} element={<DynamicPage centerJSX={page.DT_Content_EN} title={page.DT_Setting} data={page} columns={(page.DT_ColumnLeftWidth, page.DT_ColumnLeftContent, page.DT_ColumnRightWidth, page.DT_ColumnRightContent )} defaultColumns={columns}/>} exact />
//             ))
//           }
//             <Route path="/" element={<Navigate replace to={`${pages[0].DT_Setting_URL}`} />} />
//             <Route exact path={paths.SEARCH} element={<Search/>} />
//             <Route exact path={paths.DOMAIN} element={<Domain/>} />
  
//             <Route path="*" element={<Navigate replace to={`${pages[0].DT_Setting_URL}`} />} />
//           </Routes>
//   )
// }

export default RouterComponent;
